import {
  WSButton,
  WSFlexBox,
  WSPill,
  WSText
} from "@wingspanhq/fe-component-library";

import { NotificationTemplate } from "../index";
import { useBackgroundChecksRequestQuery } from "../../../../../query/backgroundChecks/queries/useBackgroundChecksRequestQuery";
import { WSQueries } from "../../../../../query/WSQuery";
import { BackgroundCheckRequestStatus } from "@wingspanhq/background-checks/dist/lib/interfaces";
import React from "react";
import { useGoToDashboardPayerRequirementDetails } from "../../../routes/RouteRequirementDetails/RoutePayerRequirementDetails";

const Body: React.FC<BackgroundCheckRequestContractorContext> = props => {
  const backgroundChecksRequestQuery = useBackgroundChecksRequestQuery(
    props.backgroundCheckRequestId
  );

  return (
    <WSQueries queries={{ backgroundChecksRequestQuery }}>
      {({ backgroundChecksRequestQueryData }) => {
        const isNew =
          backgroundChecksRequestQueryData.status ===
          BackgroundCheckRequestStatus.New;

        return (
          <>
            Company <b>{props.payer.payerName}</b> has requested a background
            check <b>{props.title}</b> to complete the onboarding process.
            {isNew ? (
              <>
                <br />
                You will receive an email with instructions shortly.
              </>
            ) : null}
          </>
        );
      }}
    </WSQueries>
  );
};
const Header: React.FC<BackgroundCheckRequestContractorContext> = props => {
  const backgroundChecksRequestQuery = useBackgroundChecksRequestQuery(
    props.backgroundCheckRequestId
  );

  return (
    <WSQueries queries={{ backgroundChecksRequestQuery }}>
      {({ backgroundChecksRequestQueryData }) => {
        return (
          <WSFlexBox.CenterY wrap="nowrap">
            <WSText.Heading5 mr="M">Background check requested</WSText.Heading5>
            {backgroundChecksRequestQueryData.status ===
            BackgroundCheckRequestStatus.New ? (
              <WSPill px="M" text="Pending" />
            ) : backgroundChecksRequestQueryData.status ===
              BackgroundCheckRequestStatus.Pending ? (
              <WSPill px="M" text="Action required" theme="warning" />
            ) : null}
          </WSFlexBox.CenterY>
        );
      }}
    </WSQueries>
  );
};

export type BackgroundCheckRequestContractorContext = {
  payerPayeeId: string;
  payerPayeeEngagementId: string;
  backgroundCheckRequestId: string;
  backgroundCheckRequestSettingsId: string;
  title: string;
  payer: {
    payerId: string;
    payerName: string;
    logoFileId?: string;
  };
  payerPayeeEngagement: { payerPayeeEngagementId: string };
  requirement: {
    requirementDefinitionId: string;
    requirementId: string;
  };
};

export const BackgroundCheckRequestContractor: NotificationTemplate<BackgroundCheckRequestContractorContext> =
  {
    renderTitle: props => "Background check requested",
    Header: props => {
      return <Header {...props.context} />;
    },
    renderBody: props => {
      // if (props.group.length > 1) {
      //   return "Your clients requested background checks to complete the onboarding process.";
      // }

      return <Body {...props.context} />;
    },
    Footer: props => {
      const goToPayerRequirementDetails =
        useGoToDashboardPayerRequirementDetails();

      const backgroundChecksRequestQuery = useBackgroundChecksRequestQuery(
        props.context.backgroundCheckRequestId
      );

      // const history = useHistory();
      //
      // if (props.group.length > 1) {
      //   return (
      //     <WSButton.Link
      //       size="S"
      //       rightIcon="chevron-right"
      //       onClick={() => {
      //         history.push("/member/dashboard/contractor-background-checks");
      //       }}
      //     >
      //       Open requests
      //     </WSButton.Link>
      //   );
      // } else
      //
      if (
        backgroundChecksRequestQuery.data?.status ===
        BackgroundCheckRequestStatus.Pending
      ) {
        return (
          <WSButton.Link
            size="S"
            rightIcon="chevron-right"
            onAsyncClick={async () => {
              goToPayerRequirementDetails({
                requirementId: props.context.requirement.requirementId,
                payerId: props.context.payer.payerId
              });
            }}
          >
            Open <b>{props.context.title}</b>
          </WSButton.Link>
        );
      } else {
        return null;
      }
    }
  };
